import React from 'react';
import { TextPassage as TextPassageStandard } from '@emorg-prd/standard-react';

interface TextPassageProps extends React.ComponentProps<typeof TextPassageStandard> {
	className?: string;
}

const TextPassage: React.FC<TextPassageProps> = (props) => {
	return <TextPassageStandard {...props} optionalClass={props.className}></TextPassageStandard>;
};

export { TextPassage };
